<template>
    <div style="height:100%" class="seeDeviceInfo">
        <el-card class="allot_card" style="overflow-y: auto;">
            <div slot="header" class="clearfix">
                <span style="line-height: 36px;">设备信息</span>
                <el-button type="info" style="float:right;" @click="editDevice" v-if="!isEdit">修改设备信息</el-button>
                <el-button type="success" style="float:right;" @click="saveEditDevice" v-if="isEdit">保存</el-button>
                <el-button type="danger" style="float:right;margin-right:20px;" @click="cancelEditDevice" v-if="isEdit">取消</el-button>
            </div>
            <div style="text-align:left;">
              <div style="display:inline-block;width:40%;margin-left:30px; min-width: 360px; max-width: 400px">
                <p>
                    <span class="d_left">设备编号</span>
                    <span>{{code}}</span>
                    <el-button v-if="Number(userType) === 0" @click="restartDevice" type="danger" style="margin-left:40px;" size="small">重启</el-button>
                </p>
                <p>
                    <span class="d_left">剩余量</span>
                    <span>{{paperNum}}</span>
                </p>
                <p>
                    <span class="d_left">使用量</span>
                    <span v-if="!isEdit">{{paperVolume}}</span>
                    <el-input type="text" v-if="isEdit" style="width:90px;" v-model="tpaperVolume"></el-input>
                    <span>包</span>
                </p>
                <p>
                    <span class="d_left">设备别名</span>
                    <span v-if="!isEdit">{{alias}}</span>
                    <el-input type="text" v-if="isEdit" style="width:210px;" v-model="talias"></el-input>
                </p>
                <p>
                    <span class="d_left">所在场景</span>
                    <span v-if="!isEdit">{{ownerName}}</span>
                    <el-select v-model="townerType" v-if="isEdit">
                        <el-option v-for="item in LocationOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </p>
                <p>
                  <span class="d_left">扫码入口</span>
                  <!-- <span>呵呵</span> -->
                  <el-button 
                    @click="btnUpdateEntryAddrQrCode()" 
                    type="text">更换二维码
                  </el-button> 
                  <el-button 
                    @click="btnRecoveryAddrQrCode()" 
                    type="text">恢复
                  </el-button>
                  </p>
                  <a target="_blank" :href="qrcodeUrl">
                      <img :src="qrcodeUrl">
                  </a>
              </div>
              <div style="position: relative;display:inline-block;vertical-align: top; margin-left: 30px">
                <p>
                    <span class="d_left">UUID</span>
                    <span>{{uuid}}</span>
                </p>
                <p>
                    <span class="d_left">补货次数</span>
                    <span>{{supplementNum}}</span>
                </p>
                <p>
                    <span class="d_left">主板系统</span>
                    <span>{{sysVersion}}</span>
                </p>
                <p>
                    <span class="d_left">固件版本</span>
                    <span>{{appVersion}}</span>
                </p>
                <p>
                    <span class="d_left">设备版本</span>
                    <span>{{deviceModel}}</span>
                </p>
                <p>
                    <span class="d_left">用电方式</span>
                    <span>{{electricType}}</span>
                </p>
                <p>
                    <span class="d_left">商户</span>
                    <span>{{merchantName}}</span>
                </p>
                <p>
                    <span class="d_left">销售</span>
                    <span>{{businessName}}</span>
                </p>
                <p>
                    <span class="d_left">运营</span>
                    <span>{{operationName}}</span>
                </p>
              </div>
              <div style="margin-left: 30px;">
                 <p>
                    <span class="d_left">经纬度</span>
                    <span>经坐标：</span><span style="color:deepskyblue;margin-right:15px;">{{longitude}}</span>
                    <span>纬坐标：</span><span style="color:deepskyblue;">{{latitude}}</span>
                </p>  
                <p>
                  <span class="d_left">设备地址:</span>
                    <span>街道信息: </span>
                    <span style="margin-right:20px;color:lightseagreen;font-size: 15px;" v-if="!isEdit">{{address1}}</span>
                    <span style="margin-right:20px;color:lightseagreen;font-size: 15px;" v-if="isEdit">{{taddress1}}</span>
                    <span>详细位置:</span>
                    <span v-if="!isEdit" style="color:lightseagreen;font-size: 15px;">{{address2}}</span>
                    <el-input type="text" v-if="isEdit" style="width:500px;" v-model="taddress2"></el-input>
                </p>
              </div> 
              <div class="amap-wrapper">
                  <el-amap-search-box class="search-box" :search-option="searchOption" :on-search-result="onSearchResult"></el-amap-search-box>
                  <el-amap vid="amapDemo" :center="mapCenter" :zoom="zoom" :events="myClick.events">
                      <el-amap-marker v-for="marker in markers" :position="marker.position" :key="marker.value" :events="marker.events" :visible="marker.visible" :draggable="marker.draggable"></el-amap-marker>
                  </el-amap>
              </div>
            </div>
        </el-card>
        <edit-entry-qrcode-box
          v-if="editEntryShow"
          :deviceCode= "deviceCode"
          @closeEditEntryBox="closeEditEntryBox"
        ></edit-entry-qrcode-box>
    </div>
</template>
<script>
    import $axios from '../../https/config'
    import {isNull} from '../../js/tool'
    import editEntryQrcodeBox from '@/page/deviceMgr/editEntryQrcodeBox'

    export default {
      props: ['deviceCode'],
      data () {
        return {
          isEdit: false,
          serachValue: '',
          zoom: 18,
          longitude: '121.5273285',
          latitude: '31.197646',
          code: '',
          deviceModel: '',
          paperNum: 0,
          electricType: '',
          supplementNum: 0,
          paperVolume: 0,
          tpaperVolume: 0,
          uuid: '',
          sysVersion: '',
          appVersion: '',
          alias: '',
          talias: '',
          ownerType: '',
          ownerName: '',
          townerType: '',
          taddress1: '',
          address1: '',
          address2: '',
          taddress2: '',
          LocationOptions: this.$store.state.spaceDataList,
          qrcodeUrl: '',
          businessName: '无',
          operationName: '无',
          merchantName: '无',
          userType: this.$store.state.userType,
          editEntryShow: false,
          markers: [
            {
              position: [113.868533, 22.560019],
              events: {
                click: () => {
                },
                dragend: (e) => {
                  this.markers[0].position = [e.lnglat.lng, e.lnglat.lat]
                  this.longitude = e.lnglat.lng
                  this.latitude = e.lnglat.lat
                }
              },
              visible: true,
              draggable: true
            }
          ],
          myClick: {
            events: {
              click: (e) => {
                var that = this
                this.markers[0].position = [e.lnglat.lng, e.lnglat.lat]
                this.longitude = e.lnglat.lng
                this.latitude = e.lnglat.lat
                // 这里通过高德 SDK 完成。
                var geocoder = new AMap.Geocoder({
                  radius: 1000,
                  extensions: 'all'
                })
                geocoder.getAddress([e.lnglat.lng, e.lnglat.lat], function (status, result) {
                  if (status === 'complete' && result.info === 'OK') {
                    if (result && result.regeocode) {
                      if (that.isEdit) {
                        that.taddress1 = result.regeocode.formattedAddress
                        that.$nextTick()
                      }
                    }
                  }
                })
              }
            }
          },
          searchOption: {
            city: '全国',
            citylimit: false
          },
          mapCenter: [113.868533, 22.560019]
        }
      },
      created: function () {
        this.queryDeviceInfo()
      },
      methods: {
        btnUpdateEntryAddrQrCode () {
          this.editEntryShow = true
        },
        btnRecoveryAddrQrCode () {
          this.$confirm('此操作将初始化二维码入口地址, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'error',
            beforeClose: (action, instance, done) => {
              if (action === 'confirm') {
                var _this = this
                var params = {
                  deviceCode: _this.deviceCode
                }
                var url = '/para/resetDeviceQrcode'
                $axios.get(url, params, 'headers', function (res) {
                  done()
                  if (res.resultStatus) {
                    _this.$message({
                      type: 'success',
                      message: '编号为' + _this.deviceCode + '的设备初始化入口二维码地址成功!'
                    })
                    _this.queryDeviceInfo()
                  } else {
                    _this.$message({
                      message: '初始化二维码失败' + res.errorMessage,
                      type: 'error'
                    })
                  }
                }, function (err) {
                  done()
                  _this.loading = false
                  _this.$message({
                    type: 'error',
                    duration: 1000 * 5,
                    message: '服务器异常，请稍后再试!' + err
                  })
                })
              } else {
                done()
              }
            }
          }).then(() => {
          }).catch(() => {
            this.loading = false
            this.$message({
              type: 'info',
              message: '已取消删除'
            })
          })
        },
        closeEditEntryBox () {
          this.editEntryShow = false
          this.queryDeviceInfo()
        },
        boxClose (tType) {
          this.$emit('boxClose', tType)
        },
        queryDeviceInfo () {
          var _this = this
          var params = {
            deviceCode: _this.deviceCode
          }
          $axios.get('/third/queryDeviceByCode', params, 'headers', function (res) {
            if (res && res.resultStatus === true) {
              if (res.resultData && res.resultData.list.length > 0) {
                for (var i = 0; i < res.resultData.list.length; i++) {
                  var itemData = res.resultData.list[i]
                  _this.code = itemData.deviceCode
                  _this.deviceModel = itemData.deviceModel
                  _this.paperNum = itemData.paperNum
                  _this.electricType = '电源适配器'
                  _this.supplementNum = itemData.supplementNum
                  _this.paperVolume = itemData.paperVolume
                  _this.uuid = itemData.uuid
                  _this.sysVersion = itemData.sysVersion
                  _this.appVersion = itemData.appVersion
                  _this.alias = itemData.alias
                  _this.ownerType = itemData.ownerType
                  _this.ownerName = _this.getDeviceSpaceValue(_this.LocationOptions, itemData.ownerType)
                  _this.longitude = itemData.longitude
                  _this.latitude = itemData.latitude
                  _this.qrcodeUrl = itemData.qrcode.qrcodeUrl
                  _this.businessName = isNull(itemData.businessName) ? '无' : itemData.businessName
                  _this.operationName = isNull(itemData.operationName) ? '无' : itemData.operationName
                  _this.merchantName = isNull(itemData.merchantName) ? '无' : itemData.merchantName
                  if (_this.latitude !== '0.0' && !isNull(_this.latitude)) {
                    _this.markers[0].position = [_this.longitude, _this.latitude]
                    _this.mapCenter = [_this.longitude, _this.latitude]
                  }
                  _this.address1 = itemData.address.split('|')[0]
                  _this.address2 = itemData.address.split('|')[1]
                  _this.getOwnerType()
                }
              }
            } else {
            }
          }, function () {
          })
        },
        getDeviceSpaceValue (items, index) {
          var returnData
          if (isNull(index) || isNull(items)) {
            returnData = '无'
          } else {
            for (var i = 0; i < items.length; i++) {
              if (index === items[i].id) {
                returnData = items[i].name
              }
            }
          }
          return returnData
        },
        getOwnerType () {
          for (var i = 0; i < this.LocationOptions.length; i++) {
            if (this.LocationOptions[i].value === this.ownerType) {
              this.ownerName = this.LocationOptions[i].label
            }
          }
        },
        onSearchResult (pois) {
          let latSum = 0
          let lngSum = 0
          if (pois.length > 0) {
            pois.forEach(poi => {
              let {lng, lat} = poi
              lngSum += lng
              latSum += lat
              this.markers[0].position.push([poi.lng, poi.lat])
            })
            let center = {
              lng: lngSum / pois.length,
              lat: latSum / pois.length
            }
            this.mapCenter = [center.lng, center.lat]
          }
        },
        restartDevice () {
          var that = this
          var params = {
            uuid: that.uuid
          }
          $axios.get('/device/pushRestart', params, 'headers', function (res) {
            if (res && res.resultStatus === true) {
              that.$message({
                message: '设备已重启',
                type: 'success'
              })
            } else {
              that.$message({
                message: '设备重启失败',
                type: 'error'
              })
            }
          }, function () {
          })
        },
        editDevice () {
          this.tpaperVolume = this.paperVolume
          this.taddress1 = this.address1
          this.taddress2 = this.address2
          this.talias = this.alias
          this.townerType = this.ownerType
          this.isEdit = true
        },
        cancelEditDevice () {
          this.isEdit = false
        },
        saveEditDevice () {
          var that = this
          var params = {
            deviceCode: that.deviceCode,
            ownerType: that.townerType,
            address: that.taddress1 + '|' + that.taddress2,
            alias: that.talias,
            longitude: that.longitude,
            latitude: that.latitude,
            longitude_baidu: that.mapCenter[0],
            latitude_baidu: that.mapCenter[1],
            paperVolume: that.tpaperVolume
          }
          $axios.post('/device/updateDeviceInfo', params, 'headers', function (res) {
            if (res && res.resultStatus === true) {
              that.boxClose()
              that.$message({
                message: '修改设备信息成功',
                type: 'success'
              })
            } else {
            }
          }, function () {
          })
          this.isEdit = false
        }
      },
      components: {
        'edit-entry-qrcode-box': editEntryQrcodeBox
      }
    }
</script>
<style lang="scss">
    .allot_card {
        margin: 10px;
        position: relative;
        overflow-y: auto;
        height: 90%;
        padding-bottom: 20px;

        .el-card__header {
            padding: 10px;
        }
        .el-card__body {
            padding: 10px;
        }
    }
    .seeDeviceInfo {
      .d_left {
        width: 90px;
        display: inline-block;
        font-weight: 600;
        }
        a>img {
            width: 160px; 
            height:160px; 
            background: rgba(0, 0, 0, .2);
        }
        .amap-wrapper {
            width: 900px;
            height: 600px;
            margin-left: 30px;
            margin-top: -30px;
            margin-bottom: 30px;
        }
        .search-box {
            top: 65px;
            left: 20px;
        }
        .seeAdMask {
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            position: fixed;
            background: rgba(0, 0, 0, 0.3);
            z-index: 1001;
            
            .box {
                width: 400px;
                background: white;
                border-radius: 5px;
                box-shadow: 0 0 10px #666;
                top: 30%;
                left: 50%;
                margin-left: -200px;
                position: absolute;

                .el-button {
                    width: 40%;
                    margin: 4%;
                }
            }
        }
    }
    
</style>


// WEBPACK FOOTER //
// src/page/deviceMgr/seeDeviceInfo.vue